define("shared/components/shared/profile-categorization/categorize-steps/progress-bar", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tSC--avatar u--m__b__xs">
    {{#if @socialProfile.isCreator}}
      <img class="tSC--avatar__img" src="/assets/images/img--signUp--igCreator.svg">
    {{else if @socialProfile.isBusiness}}
      <img class="tSC--avatar__img" src="/assets/images/img--signUp--igBusiness.svg">
    {{else}}
      <img class="tSC--avatar__img" src="/assets/images/img--signUp--igPersonal.svg">
    {{/if}}
    <svg>
      <circle class="tSC--avatar__circle" cx="33" cy="33" r="30"/>
      <circle class={{concat "tSC--avatar__loader " this.progressClass}} cx="33" cy="33" r="30"/>
    </svg>
  </div>
  */
  {
    "id": "Km0x1MW9",
    "block": "[[[10,0],[14,0,\"tSC--avatar u--m__b__xs\"],[12],[1,\"\\n\"],[41,[30,1,[\"isCreator\"]],[[[1,\"    \"],[10,\"img\"],[14,0,\"tSC--avatar__img\"],[14,\"src\",\"/assets/images/img--signUp--igCreator.svg\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isBusiness\"]],[[[1,\"    \"],[10,\"img\"],[14,0,\"tSC--avatar__img\"],[14,\"src\",\"/assets/images/img--signUp--igBusiness.svg\"],[12],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,\"img\"],[14,0,\"tSC--avatar__img\"],[14,\"src\",\"/assets/images/img--signUp--igPersonal.svg\"],[12],[13],[1,\"\\n  \"]],[]]]],[]]],[1,\"  \"],[10,\"svg\"],[12],[1,\"\\n    \"],[10,\"circle\"],[14,0,\"tSC--avatar__circle\"],[14,\"cx\",\"33\"],[14,\"cy\",\"33\"],[14,\"r\",\"30\"],[12],[13],[1,\"\\n    \"],[10,\"circle\"],[15,0,[28,[37,1],[\"tSC--avatar__loader \",[30,0,[\"progressClass\"]]],null]],[14,\"cx\",\"33\"],[14,\"cy\",\"33\"],[14,\"r\",\"30\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@socialProfile\"],false,[\"if\",\"concat\"]]",
    "moduleName": "shared/components/shared/profile-categorization/categorize-steps/progress-bar.hbs",
    "isStrictMode": false
  });

  class ProgressBar extends _component2.default {
    get progressClass() {
      const value = Number(this.args.progressValue.toFixed(1)) * 10;
      return "tSC--avatar__loader".concat(value);
    }

  }

  _exports.default = ProgressBar;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProgressBar);
});